const MOBILE_WINDOW_WIDTH = 768;

export function registerEventHandlers(element) {
  window.addEventListener('resize', () => handleWindowResize(element));
}

function handleWindowResize(parent) {
  const cards = parent.querySelectorAll('af-variation-card');
  cards.forEach((card) => {
    card.toggleAttribute('isMobile', window.innerWidth <= MOBILE_WINDOW_WIDTH);
  });
}
